export const CHANGE_CHOSEN_SUBJECT =
  'CHANGE_CHOSEN_SUBJECT';

export const changeChosenSubject = (subject) => {
  return {
    type: CHANGE_CHOSEN_SUBJECT,
    payload: subject,
  };
};
